import Vue from 'vue';
import Endpoints from "@/share/Endpoints";

export const getAffiliates = async ( {commit}, query ) => {
  try {
    let url = `${Endpoints.memberAffiliates}?page=${query.page}&limit=${query.limit}`
    if(query.name){
      url = url +`&name=${query.name}`  
    }
    if(query.validationStatus){
      url = url +`&validationStatus=${query.validationStatus}`  
    }
    if (query.branch) {
      url = url +`&branch=${query.branch}`  
    }
    let affiliates = await Vue.axios({
      method: 'GET',
      url
    });
    commit('setAffiliates', affiliates);
    return {status: true, affiliates: affiliates};
  } catch (error) {
    return {status: false, message: error}
  }
}
export const getAffiliate = async ( {commit},{ memberId, memberBranchId} ) => {
  try {
    console.log(memberId, memberBranchId);
    let affiliate = await Vue.axios({
      method: 'GET',
      url: (Endpoints.memberAffiliate.replace(':memberId', memberId)).replace(':memberBranchId', memberBranchId),
    });
    return {status: true, affiliate: affiliate.data.user, currentBranch: affiliate.data.organization? affiliate.data.organization.company : ''};
  } catch (error) {
    return {status: false, message: error}
  }
}

export const addAffiliate = async ( {commit}, { affiliate, organization, branch } ) => {
  try {
    let newAffiliate = await Vue.axios({
      method: 'POST',
      url: Endpoints.createMemberAffiliate+`/${organization}/${branch}`,
      data: affiliate
    });
    // commit('addAffiliate', newAffiliate.data.user);
    return {status: true, affiliate: newAffiliate.data.user};
  } catch (error) {
    console.log(error)
    if (error.response.status === 500) {
      return {status: false, message: "Este email ya esta registrado, intente con otro"};
    }
    return {status: false, message: error}
  }
}
export const updateAffiliate = async ( {commit}, affiliate ) => {
  try {
    let updatedAffiliate = await Vue.axios({
      method: 'PUT',
      url: Endpoints.memberAffiliatesUpdate.replace(':userId', affiliate.user._id),
      data: affiliate
    });
    commit('updateAffiliate', updatedAffiliate.data.user);
    return {status: true, affiliate: updatedAffiliate.data.user};
  } catch (error) {
    return {status: false, message: error}
  }
}
export const deleteAffiliate = async ( {commit}, affiliate ) => {
  try {
    await Vue.axios({
      method: 'DELETE',
      url: Endpoints.memberAffiliatesDelete.replace(':userId', affiliate._id)
    });
    commit('deleteAffiliate', affiliate);
    return {status: true, affiliate: affiliate};
  } catch (error) {
    return {status: false, message: error}
  }
}

export const exportAffiliates = async ( {}, query ) => {
  try {
    const buildUrl = (page, limit) => {
      let url = `${Endpoints.memberAffiliates}?page=${page}&limit=${limit}`;
      if (query.name) url += `&name=${query.name}`;
      if (query.validationStatus) url += `&validationStatus=${query.validationStatus}`;
      if (query.branch) url += `&branch=${query.branch}`;
      return url;
    };

    const exportLimit = 100;
    const firstRes = await Vue.axios({ method: 'GET', url: buildUrl(1, exportLimit) });
    const totalDocs = firstRes?.data?.totalDocs || 0;
    const pages = firstRes?.data?.totalPages
      ? Math.ceil(firstRes.data.totalDocs / exportLimit)
      : 1;

    let allMembers = firstRes?.data?.members ? [...firstRes.data.members] : [];

    for (let p = 2; p <= pages; p++) {
      const res = await Vue.axios({ method: 'GET', url: buildUrl(p, exportLimit) });
      if (res?.data?.members) {
        allMembers = allMembers.concat(res.data.members);
      }
    }

    return { status: true, members: allMembers, totalDocs };
  } catch (error) {
    return { status: false, message: error };
  }
};